import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';

export interface IFpCorrelationSummaryState {
  currentTab: FpCorrelationTabs.Summary;
  date: string | null;
  data: IFpCorrelationData | null;
  loading: boolean;
}

export const initialFpCorrelationSummaryState: IFpCorrelationSummaryState = {
  currentTab: FpCorrelationTabs.Summary,
  date: null,
  data: null,
  loading: false,
};
